// extracted by mini-css-extract-plugin
export default {"centered":"hYFIZM","header":"G2JVH7"};